<app-technician-dashboard *ngIf="user?.role?.id==='TECHNICIAN' || user?.role?.id==='DRIVER'"></app-technician-dashboard>
